import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import { ModalDialog } from '../../../../components/common/Dialogs'
import { SpacingContainer } from '../../../../components/common/Containers'
import { TextField } from '../../../../components/common/Inputs'
import { Button } from '../../../../components/common/Buttons'
import { useTrans } from '../../../../services/i18n'
import { useAlertContext } from '../../../../contexts/AlertContext'
import connect from '../../connect'

const SetupResourceModal = ({
  open,
  onClose,
  createGovernmentResource,
  getGovernmentResourcesList
}) => {
  const { trans } = useTrans()
  const { successAlert, errorAlert } = useAlertContext()
  const [isSending, setIsSending] = useState(false)
  const [form, setForm] = useState({ name: '', url: '' })

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSave = async () => {
    setIsSending(true)
    try {
      await createGovernmentResource(form)
      await getGovernmentResourcesList()
      successAlert(trans('resource-created'))
      onClose()
      setForm({ name: '', url: '' })
    } catch {
      errorAlert(trans('error-saving'))
    } finally {
      setIsSending(false)
    }
  }

  const handleCancel = () => {
    setForm({ name: '', url: '' })
    onClose()
  }

  return (
    <ModalDialog
      open={open}
      onClose={handleCancel}
      title={trans('add-government-resource')}
      actions={
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <Button variant="outlined" onClick={handleCancel} disabled={isSending}>
              {trans('cancel')}
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="success" pending={isSending} onClick={handleSave}>
              {trans('save')}
            </Button>
          </Grid>
        </Grid>
      }
    >
      <SpacingContainer px={3} py={2}>
        <TextField
          fullWidth
          label={trans('name')}
          name="name"
          value={form.name}
          onChange={handleChange}
          style={{ marginBottom: '16px' }}
        />
        <TextField
          fullWidth
          label={trans('url')}
          name="url"
          value={form.url}
          onChange={handleChange}
        />
      </SpacingContainer>
    </ModalDialog>
  )
}

export default connect(SetupResourceModal)

